import React, { memo } from 'react';

const NotificationIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="16 10 110 110">
    <g>
      <path
        fill="#f4f4f4"
        d="M61.97552,11.5503c-10.33789,0-21.06635,2.79383-29.3924,7.43736
 c-5.43182,3.02881-10.22369,7.48785-12.77545,13.16033c-3.49231,7.75641-2.46674,16.71638-1.16119,25.1231
 c0.93451,6.02718,2.09564,12.31277,5.84662,17.12494c3.46283,4.4403,8.74603,7.08839,14.08698,8.86811
 c6.31555,2.10343,12.92487,3.17974,19.55188,3.6557c2.99603,0.21443,6.23926,0.52983,9.44214,0.52983
 c3.12018,0,6.20233-0.29926,8.98053-1.28501c4.49628-1.59495,8.23157-4.82623,11.42279-8.37211
 c3.71118-4.11866,6.82922-8.91079,9.02271-14.03757c3.30652-7.72726,4.50659-16.21777,2.45398-24.31742
 c-2.67004-10.52265-10.65613-21.17723-20.97351-25.09369C73.42877,12.42572,67.76276,11.5503,61.97552,11.5503"
      />
    </g>
  </svg>
);
export default memo(NotificationIcon);
